import type { SVGProps } from 'react';

export function UserCircleIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 20"
      className="h-5 w-5 text-[rgba(0,0,0,0.9)]"
      fill="none"
    >
      <path
        d="M10 18.125a8.125 8.125 0 1 0 0-16.25 8.125 8.125 0 0 0 0 16.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M10 10a2.875 2.875 0 1 0 0-5.75A2.875 2.875 0 0 0 10 10Zm0 1.5c-2.255 0-4.17 1.28-4.938 3.125h9.876C14.17 12.78 12.255 11.5 10 11.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function LanguageIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 20"
      className="h-5 w-5 text-[#2C2C2C]"
      fill="none"
    >
      <circle cx="10" cy="10" r="7" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M3 10h14M10 3c2.2 2.1 3.4 4.48 3.4 7S12.2 14.9 10 17M10 3C7.8 5.1 6.6 7.48 6.6 10S7.8 14.9 10 17"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

function BaseMeetingIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    />
  );
}

type MeetingIconProps = {
  small?: boolean;
};

export function CalendarIcon({ small = false }: MeetingIconProps) {
  const iconSize = small ? 16 : 20;
  const iconColor = small ? '#0052D9' : '#B5C7FF';

  return (
    <BaseMeetingIcon width={iconSize} height={iconSize}>
      <path
        d="M9.99984 18.3332C14.6022 18.3332 18.3332 14.6022 18.3332 9.99984C18.3332 5.39746 14.6022 1.6665 9.99984 1.6665C5.39746 1.6665 1.6665 5.39746 1.6665 9.99984C1.6665 14.6022 5.39746 18.3332 9.99984 18.3332Z"
        fill={iconColor}
        stroke={iconColor}
        strokeWidth="0.833333"
        strokeLinejoin="round"
      />
      <path
        d="M10.0034 5L10.0029 10.0037L13.536 13.5368"
        stroke="white"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseMeetingIcon>
  );
}

export function LocationIcon({ small = false }: MeetingIconProps) {
  if (small) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.6 6.4C9.6 5.96 9.44333 5.58333 9.13 5.27C8.81667 4.95667 8.44 4.8 8 4.8C7.56 4.8 7.18333 4.95667 6.87 5.27C6.55667 5.58333 6.4 5.96 6.4 6.4C6.4 6.84 6.55667 7.21667 6.87 7.53C7.18333 7.84333 7.56 8 8 8C8.44 8 8.81667 7.84333 9.13 7.53C9.44333 7.21667 9.6 6.84 9.6 6.4ZM1.6001 6.56C1.6001 4.56 2.24343 2.96667 3.53009 1.78C4.81676 0.593328 6.30676 0 8.0001 0C9.69344 0 11.1834 0.593328 12.4701 1.78C13.7568 2.96667 14.4001 4.56 14.4001 6.56C14.4001 7.89333 13.8701 9.34333 12.8101 10.91C11.7501 12.4767 10.1468 14.1733 8.0001 16C5.85344 14.1733 4.25009 12.4767 3.1901 10.91C2.13009 9.34333 1.6001 7.89333 1.6001 6.56Z"
          fill="#0052D9"
        />
      </svg>
    );
  }

  return (
    <BaseMeetingIcon>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 8C12 7.45 11.8042 6.97917 11.4125 6.5875C11.0208 6.19583 10.55 6 10 6C9.45 6 8.97917 6.19583 8.5875 6.5875C8.19583 6.97917 8 7.45 8 8C8 8.55 8.19583 9.02083 8.5875 9.4125C8.97917 9.80417 9.45 10 10 10C10.55 10 11.0208 9.80417 11.4125 9.4125C11.8042 9.02083 12 8.55 12 8ZM2 8.2C2 5.7 2.80416 3.70834 4.4125 2.225C6.02083 0.74166 7.88333 0 10 0C12.1167 0 13.9792 0.74166 15.5875 2.225C17.1958 3.70834 18 5.7 18 8.2C18 9.86666 17.3375 11.6792 16.0125 13.6375C14.6875 15.5958 12.6833 17.7167 10 20C7.31667 17.7167 5.3125 15.5958 3.9875 13.6375C2.6625 11.6792 2 9.86666 2 8.2Z"
        fill="#B5C7FF"
      />
    </BaseMeetingIcon>
  );
}

export function DeleteActionIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
    >
      <path d="M7.5 15V7.5H8.75V15H7.5Z" fill="black" fillOpacity="0.4" />
      <path d="M11.25 7.5V15H12.5V7.5H11.25Z" fill="black" fillOpacity="0.4" />
      <path
        d="M13.125 3.75H17.5V5H16.25V17.5C16.25 18.1904 15.6904 18.75 15 18.75H5C4.30964 18.75 3.75 18.1904 3.75 17.5V5H2.5V3.75H6.875L6.875 2.25C6.875 1.69772 7.32272 1.25 7.875 1.25H12.125C12.6773 1.25 13.125 1.69772 13.125 2.25V3.75ZM8.125 3.75H11.875L11.875 2.5L8.125 2.5V3.75ZM5 5V17.5H15V5H5Z"
        fill="black"
        fillOpacity="0.4"
      />
    </svg>
  );
}
